module.exports = __webpack_public_path__ + "static/media/black-back-strip.ee586101.png";